export const STATUSES = [
  'ready_to_reclaim',
  'need_more_info',
  'deselected',
  'not_reclaimable',
]
